import { styled } from "styled-components";

export const ValidationMessage = styled.span`
  font-size: 12px;
  color: red;
`;
